module.exports = __webpack_public_path__ + "img/V1.149e8c92.jpg";